import { FeatureFlag } from '../FeatureFlag';

export const enableOwnerInvitation = new FeatureFlag({
    key: 'enable-owner-invitation',
    defaultValue: false,
});
